// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.streams-drawer-top-bar-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
}
.streams-drawer-top-bar-container .streams-drawer-top-bar {
  background-color: #fff;
  height: 56px;
  box-shadow: 0 2px 5px 1px #adb3b8;
  position: relative;
}
.streams-drawer-top-bar-container .streams-drawer-top-bar .streams-drawer-close-button {
  cursor: pointer;
}
.streams-drawer-top-bar-container .streams-drawer-top-bar .streams-drawer-close-button svg {
  height: 20px;
  vertical-align: bottom;
  width: 20px;
}
.streams-drawer-top-bar-container .streams-drawer-top-bar .cu-white-loading-spinner {
  width: 20px;
  height: 20px;
  margin: 0 8px 0 0;
}
.streams-drawer-top-bar-container .streams-drawer-top-bar cu-popover-content-container {
  margin-top: 8px;
}
.streams-drawer-top-bar-container .streams-drawer-top-bar .video-icon-wrapper {
  height: 15px;
  float: left;
}
.streams-drawer-top-bar-container .streams-drawer-top-bar .cta-button {
  border: 2px solid #fff;
  color: #fff;
  font-weight: 600;
}
.streams-drawer-top-bar-container .streams-drawer-top-bar .cta-button[disabled] {
  border: none;
}
.streams-drawer-top-bar-container .streams-drawer-top-bar .cta-button:hover {
  background-color: white;
  color: #007c92;
}
.streams-drawer-top-bar-container .streams-drawer-top-bar .uia-more-button {
  cursor: pointer;
}
.streams-drawer-top-bar-container .streams-drawer-top-bar .cu-list-item {
  cursor: pointer;
  border: none;
  width: 100%;
  background: #fff;
}
.streams-drawer-top-bar-container .streams-drawer-top-bar .videoicon svg {
  vertical-align: bottom;
}
.streams-drawer-top-bar-container .streams-drawer-top-bar .newbadge {
  vertical-align: top;
}
.streams-drawer-top-bar-container .streams-drawer-top-bar .mute-disclaimer {
  background-color: #e9eaec;
  color: #4E495C;
  font-size: small;
}
.streams-drawer-top-bar-container .streams-drawer-top-bar-selected {
  background-color: #007c92;
  color: #fff;
}
.streams-drawer-top-bar-container .streams-drawer-top-bar-selected .streams-drawer-top-bar-cta {
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./app/streams-drawer/streams-drawer-top-bar/streams-drawer-top-bar.less"],"names":[],"mappings":"AAOA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;AANF;AACA;EAQM,sBAAA;EACA,YAAA;EACA,iCAAA;EACE,kBAAA;AANR;AALA;EAcU,eAAA;AANV;AARA;EAiBc,YAAA;EACA,sBAAA;EACA,WAAA;AANd;AAbA;EAuBQ,WAAA;EACA,YAAA;EACA,iBAAA;AAPR;AAlBA;EA4BQ,eAAA;AAPR;AArBA;EA+BQ,YAAA;EACA,WAAA;AAPR;AAzBA;EAmCU,sBAAA;EACA,WAAA;EACA,gBAAA;AAPV;AASU;EACI,YAAA;AAPd;AAUU;EACI,uBAAA;EACA,cAAA;AARd;AArCA;EAkDU,eAAA;AAVV;AAxCA;EAsDQ,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AAXR;AA9CA;EA6DY,sBAAA;AAZZ;AAjDA;EAiEQ,mBAAA;AAbR;AApDA;EAoEQ,yBAAA;EACA,cAAA;EACA,gBAAA;AAbR;AAzDA;EA4EM,yBAAA;EACA,WAAA;AAhBN;AA7DA;EAgFU,WAAA;AAhBV","sourcesContent":["//\n// Copyright (c) 2011-2018 by Curalate, Inc.\n//\n\n@import (reference) '../../../css/unison';\n@import (reference) \"../../../css/curalate-variables.less\";\n\n.streams-drawer-top-bar-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n\n  .streams-drawer-top-bar {\n      background-color: @cu-white;\n      height: @uia-top-bar-height;\n      box-shadow: 0 2px 5px 1px @cu-gray-5;\n        position: relative;\n\n      .streams-drawer-close-button {\n          cursor: pointer;\n\n          svg {\n              height: 20px;\n              vertical-align: bottom;\n              width: 20px;\n          }\n      }\n      .cu-white-loading-spinner {\n        width: 20px;\n        height: 20px;\n        margin: 0 8px 0 0;\n      }\n      cu-popover-content-container {\n        margin-top: 8px;\n      }\n      .video-icon-wrapper{\n        height: 15px;\n        float: left;\n      }\n      .cta-button {\n          border: 2px solid @cu-white;\n          color: @cu-white;\n          font-weight: 600;\n\n          &[disabled] {\n              border: none;\n          }\n\n          &:hover {\n              background-color: white;\n              color: @cu-color-primary;\n          }\n      }\n\n      .uia-more-button {\n          cursor: pointer;\n      }\n\n      .cu-list-item {\n        cursor: pointer;\n        border: none;\n        width: 100%;\n        background:@cu-white;\n      }\n      .videoicon{\n        svg{\n            vertical-align: bottom;\n        }\n      }\n      .newbadge{\n        vertical-align: top;\n      }\n      .mute-disclaimer{\n        background-color: @cu-gray-1;\n        color: @cu-gray-9;\n        font-size: small;\n      }\n      \n  }\n\n  .streams-drawer-top-bar-selected {\n      background-color: @cu-color-primary;\n      color: @cu-white;\n\n      .streams-drawer-top-bar-cta {\n          color: @cu-white;\n      }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
